const configuracao = (DataBase, Datatype) => {
	const Configuracao = DataBase.new(
		{
			value: Datatype.STRING,
		},
		{
			tracked: true,
			collection: "configuracao",
			model: "Configuracao",
		}
	);

	return Configuracao;
};

export default configuracao;
